import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Header from './Header';
import Processing from './utils/Processing';
import './balloon.css';
import { Typography, Grid, Button, IconButton, TextField } from '@material-ui/core';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import ContextMenu from './ContextMenu';
import * as parser from './utils/Parser';

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
    paddingTop: theme.spacing(1),
    width: "100%",
  },
  caption: {
    textAlign: "center",
    width: "100%",
  },
  textbox: {
    width: "calc(100vmin)",
    paddingLeft: "calc(2vmin)",
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
  title: {
    marginTop: theme.spacing(1),
    marginLeft: "calc(4vmin)",
    paddingLeft: theme.spacing(2),
  },
  message: {
    marginLeft: "calc(3vmin)",
    borderRadius: "calc(1vmin)",
    width: "calc(83vmin)",
  },
  memo: {
    padding: theme.spacing(2),
    color: "#555555",
    background: "#eeeeee",
    width: "calc(83vmin)",
    marginLeft: "calc(3vmin)",
  },
  text: {
    padding: "calc(0.5vmin) calc(1vmin)",
  },
  menu: {
    padding: theme.spacing(1),
  },
  form: {
    width: "calc(100vmin)",
    paddingLeft: "calc(4vmin)",
    marginBottom: theme.spacing(1),
  },
  textField: {
    width: "calc(83vmin)",
  },
});


class Page extends React.Component {
  state = { label:"Message", uid:null, title:"", message:"", list:null, autoFocus:true }

  async componentDidMount() {
    //try {
      const { db, match:{params:{aid} }} = this.props;
      const doc = await db.collection("articles").doc(aid).get();
      const entry = doc.data();
      const refArticle = db.doc("users/" + entry.uid + "/articles/" + aid);
      const docArticle = await refArticle.get();
      const article = docArticle.data();
      this.setState({...article, uid:entry.uid});

      this.refMessages =  refArticle.collection("messages");
      this.detacher = this.refMessages.orderBy("timestamp").onSnapshot((snapshot) => {
        const list = [];
        snapshot.forEach((doc) => {
          list.push({...doc.data(), id:doc.id});
        });
        this.setState({list:list});
      });
    /*
    } catch(e) {
      this.setState({error:e});
    }
    */
  }

  componentWillUnmount() {
    if (this.detacher) {
      this.detacher();
    }
  }

  async handleChange(message) {
    this.setState({message:message});
  }

  async handleEnter(e, uid) {
    const {context, message} = this.state;
    e.preventDefault();
    var autoFocus = true;
    if (context) {
      this.refMessages.doc(context.id).set({text:message}, {merge:true});
      autoFocus = false;
    } else {
      const element = document.getElementById("textField");
      element.focus();
      this.refMessages.add({text:message, uid:uid, timestamp:new Date()});
    }
    this.setState({message:"", editing:null, context:null, autoFocus:autoFocus});
  }

  handleCancel = (e) => {
    e.preventDefault();
    this.setState({ editing:null, message:"", context:null, autoFocus:false });
  }

  handleClose = () => {
    this.setState({ anchorEl: null, context:null });
  };

  handleDelete = async () => {
    const {context} = this.state;
    const { user, db, match:{params:{aid}} } = this.props;
    const ref = db.doc("users/" + user.uid + "/articles/" + aid + "/messages/" + context.id);
    this.setState({ anchorEl:null, context:null });
    await ref.delete();
  }

  handleEdit = async (e) => {
    const {context} = this.state;
    this.setState({ anchorEl:null, editing:context.id, message:context.text });
  }

  handleMore(e, item) {
    this.setState({ anchorEl: e.currentTarget, context:item });
  }

  catchReturn = (e) => {
    const { user } = this.props;
    if (e.key==='Enter' && !e.shiftKey) {
      e.preventDefault();
      if (this.state.message.length > 0) {
        this.handleEnter(e, user.uid);
      }
    }
  }

  render() {
    const { classes, user } = this.props;
    const { anchorEl, context, editing, autoFocus } = this.state;
    const open = Boolean(anchorEl);
    const isAuthor = (user && user.uid === this.state.uid);
    if (this.state.list === null) {
      return <React.Fragment>
          <Header user={user} />
          <Processing/>
        </React.Fragment>
    }
    if (this.state.error) {
      return <React.Fragment>
        <Header user={user} />
        <Grid container justify="center" alignItems="center" direction="row"  className={classes.root}>
          <Grid item>
            { this.state.uid ?
              <h1>This article has been deleted.</h1>
              :<h1>This article does not exist.</h1> }
          </Grid>
        </Grid>
      </React.Fragment>
    }
    let base = 0;
    const linked = (text) => {
      return parser.linked(text).reduce((list, str) => {
        if (typeof str === "string") {
          processMultiLine(str, base, list);
          base += str.length * 1000;
        } else {
          list.push(<a href={str.link} key={base}>{str.text}</a>);
          base += str.text.length * 1000;
        }
        return list;
      }, []).flat();
    }

    const processMultiLine = (str, base, list) => {
      if (str.length === 0) { return }
      const array = str.split('\n');
      array.forEach((line, index)=>{
        if (index > 0) {
          list.push(<br key={base + index}/>)
        }
        list.push(line);
      });
    }
    
    const renderMessage = (item) => {
      return <Grid key={item.id} container className={classes.textbox} spacing={1}>
          {
            (item.uid) ? 
              <Grid item className={classes.message+" balloon"}>
               <div className={classes.text}>
                <Typography>{linked(item.text)}</Typography>
               </div>
            </Grid>
            :
            <Grid item className={classes.memo}>
               <div className={classes.text}>
                 <Typography>{linked(item.text)}</Typography>
               </div>
            </Grid>            
          }
          <Grid item>
            <IconButton className={classes.menu} onClick={(e)=>{this.handleMore(e, item)}}><MoreIcon fontSize="small" /></IconButton>
          </Grid>

        </Grid>
    };
    const renderEditor = (item) => {
      return (
        <form className={classes.form} key={item.id}>
          <TextField label={this.state.label} value={this.state.message} autoFocus
                className={classes.textField} margin="normal" variant="outlined"
                multiline={true} rows={2} rowsMax={6}
                onKeyPress={this.catchReturn}
                onChange = {(e)=>this.handleChange(e.target.value)} />
          <Grid container spacing={1}>
            <Grid item>
              <Button variant="outlined" color="primary" className={classes.button} type="submit"
                onClick = {(e)=>this.handleEnter(e, user.uid)}>
                Post
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" className={classes.button} type="submit"
                onClick = {(e)=>this.handleCancel(e)}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </form>
      );  
    };
    const form = (
      <form className={classes.form}>
        <TextField id="textField" label={this.state.label} value={this.state.message} autoFocus={autoFocus}
              className={classes.textField} margin="normal" variant="outlined"
              multiline={true} rows={2} rowsMax={6}
              onKeyPress={this.catchReturn}
              onChange = {(e)=>this.handleChange(e.target.value)} />
        <Grid container spacing={1}>
          <Grid item>
            <Button variant="outlined" color="primary" className={classes.button} type="submit"
              disabled = {this.state.message.length===0}
              onClick = {(e)=>this.handleEnter(e, user.uid)}>
              Post
            </Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" className={classes.button} type="submit"
              disabled = {this.state.message.length===0}
              onClick = {(e)=>this.handleEnter(e, null)}>
              Memo
            </Button>
          </Grid>
        </Grid>
      </form>
    );
    return (
      <React.Fragment>
        <Header user={user} />
          <Grid container justify="center" alignItems="center" direction="row"  className={classes.root}>
            <Grid item>
            <Typography component="h2" variant="h6" gutterBottom className={classes.title}>{this.state.title || "(untitled)"}</Typography>
            { 
              this.state.list.map((item, index)=>{
                  //return <p key={index}>{item}</p>;
                  return (editing===item.id) ? renderEditor(item) : renderMessage(item);
              })
            }
            { // mount/unmout for Twitter component
              open &&
              <ContextMenu open={open} anchorEl={anchorEl} context={context} owner={isAuthor}
                        handleClose={this.handleClose} handleDelete={this.handleDelete} handleEdit={this.handleEdit}/>
            }
            {
              isAuthor && !editing && form
            }
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

Page.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Page);
